<template>
  <div class="reserved_btns">
    <p class="balloon">ただいま<span class="clinic_state">{{ isOpen ? '診療中' : '休診中' }}</span></p>
    <a v-if="tel" :href="telNumber" class="btn btn_radius btn_tel btn_arrow_r icon-">{{ isMobile ? 'お電話でのご予約' : siteData.info.tel }}</a>
    <a v-if="mail" href="/" class="btn btn_radius btn_mail btn_arrow_r icon-">メールお問い合わせ</a>
    <!-- <a href="" class="btn btn_radius btn_reserve btn_link icon-">WEB予約はこちらから</a> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ReservedBtns',
  props: {
    msg: String,
    tel: {
      type: Boolean,
      default: true
    },
    mail: {
      type: Boolean,
      default: true
    },
    reserve: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState([
      'isMobile',
      'isOpen',
      'siteData'
    ]),
    telNumber () {
      return `tel:${this.siteData.info.tel}`
    }
  },
  mounted () {
    //console.log('mounted',this.isOpen);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
